/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const OperationsIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2859 20.5714C10.2859 20.5714 3.42871 13.6612 3.42871 9.42858C3.42871 5.08973 6.97214 2.57144 10.2859 2.57144C13.5996 2.57144 17.143 5.08973 17.143 9.42858"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M17.1427 19.7143C18.5629 19.7143 19.7141 18.563 19.7141 17.1429C19.7141 15.7227 18.5629 14.5714 17.1427 14.5714C15.7226 14.5714 14.5713 15.7227 14.5713 17.1429C14.5713 18.563 15.7226 19.7143 17.1427 19.7143Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M17.1431 14.5714V12.8571"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18.9609 15.3249L20.1738 14.112"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M19.7144 17.1429H21.4286"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18.9609 18.9608L20.1738 20.1737"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M17.1431 19.7143V21.4286"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.3247 18.9608L14.1118 20.1737"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14.5712 17.1429H12.8569"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.3247 15.3249L14.1118 14.112"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.2858 12C11.7059 12 12.8572 10.8487 12.8572 9.42858C12.8572 8.00841 11.7059 6.85715 10.2858 6.85715C8.86562 6.85715 7.71436 8.00841 7.71436 9.42858C7.71436 10.8487 8.86562 12 10.2858 12Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};
